export default "<ng-container *ngIf=\"safeSeoHtml\">\n  <div [innerHTML]=\"safeSeoHtml\"></div>\n</ng-container>\n";